import "./styles.scss";

import { useRef } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import Loader from "components/Loader";

const mainClass = "button";

const Button = ({
  children,
  fullWidth,
  variant,
  onClick,
  type = "button",
  href,
  loading,
  disabled,
  icon,
  size,
  active,
  external_href,
  external_href_blank = true,
  class_name,
  id,
}) => {
  const ref = useRef();
  const className = classnames(mainClass, class_name, {
    [`${mainClass}--icon-button`]: !!!children && icon,
    [`${mainClass}--full-width`]: !!fullWidth,
    [`${mainClass}--${variant}`]: !!variant,
    [`${mainClass}--disabled`]: !!disabled,
    [`${mainClass}--${size}`]: !!size,
    [`${mainClass}--active`]: !!active,
  });

  const props = {
    id,
    className,
    ref,
    style: { minWidth: ref?.current?.offsetWidth },
    onClick,
  };

  return href ? (
    external_href ? (
      <a
        {...props}
        href={href}
        target={!!external_href_blank ? "_blank" : "_self"}
        rel="noopener noreferrer"
      >
        {children}
        {icon}
      </a>
    ) : (
      <Link {...props} to={href}>
        {children}
        {icon}
      </Link>
    )
  ) : (
    <button {...props} type={type} disabled={disabled || !!loading}>
      {loading ? (
        <Loader />
      ) : (
        <>
          {children}
          {icon}
        </>
      )}
    </button>
  );
};

export default Button;
